import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'
import { NgxSpinnerService } from 'ngx-spinner'
import { title } from 'process'
import { ResponseWarehouseNameLocation } from 'src/app/_models'
import { AuthenticationService } from 'src/app/_services'
import { environment } from 'src/environments/environment'
import Swal from 'sweetalert2'

@Component({
  selector: 'app-warehouse-name-location',
  templateUrl: './warehouse-name-location.component.html',
  styleUrls: ['./warehouse-name-location.component.css']
})
export class WarehouseNameLocationViewComponent implements OnInit {
  formWarehouse: FormGroup
  objectKeys = Object.values
  objectKeys2 = Object.values
  displayedColumns = []
  ArrayDataReport2 = []
  viewTable = false
  dtoptions = {}
  PlaceOrderCustomer = []
  ResponseWarehouseNameLocationArray: ResponseWarehouseNameLocation[]
  btnRemoveInventory = false  
  constructor (
    private _httpClient: HttpClient,
    private formbuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private authenticationService: AuthenticationService
  ) {
    this.PlaceOrderCustomer = []
    this.ResponseWarehouseNameLocationArray = []
    this.displayedColumns = []
    this.ArrayDataReport2 = []
  }

  ngOnInit (): void {
    //  this.onTableWarehouseNameLocation()
    try {
      if (this.authenticationService.currentUserValue.company == 'LDT20') {
      
        if(this.authenticationService.currentUserValue.useremail==='cgaxiola@linedrivetrucking.com'){

          this.btnRemoveInventory = true  
        }else if(this.authenticationService.currentUserValue.useremail==='rsanchez@linedrivetrucking.com'){

          this.btnRemoveInventory = true  
        }else if(this.authenticationService.currentUserValue.useremail==='LDT20@3plfreightsoftware.com'){

          this.btnRemoveInventory = true  
        }
      } else {
        this.btnRemoveInventory = true  
      }
    } catch (error) {}
    this.OnSelectCostumer()
    this.formWarehouse = this.formbuilder.group({
      warehouse: [''],
      customer: ['']
    })
  }
  onTableWarehouseNameLocation () {
    this._httpClient
      .get<any>(
        `${environment.apiUrl}/Administracion/warehouseNameLocationSelectGet?CompanyID=${this.authenticationService.currentUserValue.companyIdWh}&active=1`,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: ResponseWarehouseNameLocation[]) => {
        this.ResponseWarehouseNameLocationArray = []
        this.ResponseWarehouseNameLocationArray = response
      })
  }
  OnSelectCostumer () {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var Request = {}
    Request['companyId'] = json.companyIdWh
    Request['active'] = '1'

    this._httpClient
      .post<any>(`${environment.apiUrl}/Shipping/PlaceOrderCustomer`, Request, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + json.token
        })
      })
      .subscribe((response: any) => {
        this.PlaceOrderCustomer = response
      })
  }

  OnSelectTypeReportsGenerated () {
    this.spinner.show()
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    this.viewTable = false
    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Administracion/warehouseNameLocationProductsSelectGet?CompanyID=${Number(
          this.authenticationService.currentUserValue.companyIdWh
        )}&customerId=${Number(
          this.formWarehouse.controls.customer.value
        )}&active=1`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: any) => {
        try {
          this.spinner.hide()
          this.displayedColumns = []
          this.ArrayDataReport2 = []

          this.dtoptions = null
          for (let index = 0; index < 1; index++) {
            this.displayedColumns = Object.keys(response[index])
          }
          this.ArrayDataReport2 = response
          try {
            this.dtoptions = {
              pagingType: 'full_numbers',
              pageLength: 1000,
              processing: true,
              scrollX: true,
              scrollY: '70vh',
              dom: 'Bfrtip',
              order: [],
              buttons: [
                'colvis',
                'copy',
                {
                  extend: 'csvHtml5',
                  text: 'CSV',
                  exportOptions: {
                    modifier: {
                      search: 'applied',
                      selected: true
                    },
                    columns: ':visible'
                  }
                },
                {
                  extend: 'print',
                  text: 'PDF',
                  exportOptions: {
                    modifier: {
                      search: 'applied',
                      selected: true
                    },
                    columns: ':visible'
                  }
                }
              ],
              responsive: false,
              columnDefs: [
                {
                  targets: 1,
                  title: 'Item Number'
                },
                {
                  targets: 2,
                  title: 'Item Description'
                }
              ] 
              
            }

            this.viewTable = true
          } catch (error) {
            this.viewTable = false
          }
        } catch (error) {
          this.viewTable = false
        }
      })
  }
  onRemoveInventory(Datos: any) {
    console.log(Datos,'onRemoveInventory')
    var Request = {}
    Request['id'] = Number(Datos)

     this._httpClient
      .post<any>(
        `${environment.apiUrl}/Receive/removeInventoryReceiving`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        Swal.fire({
          icon: 'info',
          title: 'Delete',
          text: response.responses
        })
       
        
      }) 
  }







}
